export const API_URL = () => process.env.REACT_APP_BASE_URL;
export const REACT_DRUPAL_URL = () => process.env.REACT_APP_DRUPAL_BASE_URL;

//
//
// export const API_URL = () => "https://uat-nmp-api.startupindia.gov.in/";
// export const REACT_DRUPAL_URL = () => "https://uat-nmpweb.startupindia.gov.in/";
// export const API_URL = () => "https://maarg-api.startupindia.gov.in/mentorship-app/";
// export const REACT_DRUPAL_URL = () => "https://maarg-api.startupindia.gov.in/mentorship-app";

// export const REACT_DRUPAL_APP_BASE_URL ="https://uat-nmpweb.startupindia.gov.in/";
// export const REACT_APP_BASE_URL = "https://uat-nmp-api.startupindia.gov.in/";

export const COHORT_ENGAGED_MENTORS = `${API_URL()}v1/cohort/get-mentor-cohort-list`;
export const COHORT_PROGRAM_TOTAL_MENTORS = `${API_URL()}v1/cohort/mentor/list`;
export const LOGIN_POPUP_COHORT_COUNTER = `${API_URL()}v1/cohort/cohortProgramCountersForPopup`;
export const COUNTER_MENTOR_REQUESTS = `${API_URL()}v1/mentor_algo_ml/mentor_request_list_counters`;
export const TABLELIST_MENTOR_REQUESTS = `${API_URL()}v1/mentor_algo_ml/mentor_requests_for_admin`;
export const COHORT_ENGAGED_STARTUPS = `${API_URL()}v1/cohort/get-startup-cohort-list`;
export const COHORT_NAME_LIST = `${API_URL()}v1/cohort/name/list`;
export const GROUP_SESSION_NAME_LIST = `${API_URL()}v1/user/name/list`;
export const COHORT_REQUEST_COUNTER = `${API_URL()}v1/cohort/cohort-ount`;
export const COHORT_ADMIN_COUNTER = `${API_URL()}v1/cohort/cohortMatchCounters`;
export const COHORT_PARTICIPANT_COUNTER = `${API_URL()}v1/cohort/cohortParticipantsCount`;
export const ORGANIZATION_NAME_LIST = `${API_URL()}v1/cohort/organization/list`;
export const CURRENT_INTERVENTION = `${REACT_DRUPAL_URL()}msp/api/v1/homepage`;
export const GET_A_MENTOR_FORM = `${REACT_DRUPAL_URL()}msp/api/v1/mentee-application-form`;
export const FACEBOOK_LOGIN = `${API_URL()}v1/validateFacebookLogin`;
export const STARTUP_INDIA_LOGIN = `${API_URL()}v1/validateDpiitLogin`;
export const GOOGLE_LOGIN = `${API_URL()}v1/validateGoogleLogin`;
export const LINKEDIN_LOGIN = `${API_URL()}v1/validateLinkedinLogin`;
export const LOGIN_DATA = `${API_URL()}v1/auth`;
// export const LOGIN_DATA_UAT = `https://uat-nmp-api.startupindia.gov.in/v1/auth`;
export const LOGOUT_URL = `${API_URL()}v1/logout`;
export const REFRESH_TOKEN_URL = `${API_URL()}v1/refresh_token`;
export const REGISTER_MENTOR = `${API_URL()}v1/mentor/register`;
export const REGISTER_EDIT_MENTOR = `${API_URL()}v1/mentor/updateApplication`;
export const REGISTER_STARTUP = `${API_URL()}v1/startup/register`;
export const SAVE_DRAFT_STARTUP = `${API_URL()}v1/startup/saveAsDraft`;
export const SAVE_DRAFT_COHORT = `${API_URL()}v1/cohort/saveAsDraft`;
export const REGISTER_COHORT = `${API_URL()}v1/cohort/register`;
export const REGISTER_STARTUP_COHORT = `${API_URL()}v1/cohort/startup/register`;
export const CURRENT_DASHBOARD_PROFILE = `${REACT_DRUPAL_URL()}msp/api/v1/homepage`;
export const CURRENT_DASHBOARD_ADMIN = `${REACT_DRUPAL_URL()}msp/api/v1/homepage`;
export const DASHBOARD_MENTOR_MYREQUEST = `${REACT_DRUPAL_URL()}msp/api/v1/homepage`;
export const DASHBOARD_STARTUP_MYREQUEST = `${REACT_DRUPAL_URL()}msp/api/v1/homepage`;
export const ADMIN_DASHBOARD_MENTOR_APPLICATION = `${API_URL()}v1/mentor/list-application-paged`;
export const ADMIN_DASHBOARD_COHORT_GRAPH_API = `${API_URL()}v1/cohort/cohortApplication/counter`;
export const ADMIN_DASHBOARD_MENTOR_GRAPH_API = `${API_URL()}v1/mentorship/getMentorshipsOfMentorsCount`;
export const ADMIN_DASHBOARD_SPOTLIGHT_LIST = `${API_URL()}v1/cohort/cohortApplication/adminlist`;
export const ADMIN_DASHBOARD_SPOTLIGHT_CALENDAR = `${API_URL()}v1/cohort-session/get-list-cohort-group-sessionforall`;
export const PUBLIC_LIST_GROUP_SESSIONS = `${API_URL()}v1/cohort-session/getPagedPubliclistOfCohortGroupSessions`;
export const VIEW_APPLICATION_DATA = `${API_URL()}v1/mentor/view-application`;
export const VIEW_STARTUP_APPLICATION_DATA = `${API_URL()}v1/startup/view-application`;
export const VIEW_COHORT_APPLICATION_DATA = `${API_URL()}v1/cohort/view-application`;
export const VIEW_PREDEFINED_OPTIONS = `${REACT_DRUPAL_URL()}msp/api/v1/predefine-options`;
export const UPDATE_APPLICATION_STATUS = `${API_URL()}v1/mentor/update-application`;
export const VIEW_COUNTER_OPTIONS = `${API_URL()}v1/mentor/application-counters`;
export const VIEW_COUNTER_SESSIONS = `${API_URL()}v1/mentor_algo_ml/session_counters`;
export const VIEW_COUNTER_HOURS = `${API_URL()}v1/mentor_algo_ml/session_hour_counters`;
export const VIEW_COUNTER_STARTUP_OPTIONS = `${API_URL()}v1/mentor_algo_ml/search_list_counters`;
export const VIEW_COUNTER_MENTOR_OPTIONS = `${API_URL()}v1/mentor_algo_ml/requests_counter_for_mentor`;
export const VIEW_MENTORLIST_COUNTER_OPTIONS = `${API_URL()}v1/mentor/counters`;
export const VIEW_STARTUPLST_COUNTER_OPTIONS = `${API_URL()}v1/startup/counters`;
export const VIEW_STARTUPLST_SUBMITTED_COUNTER_OPTIONS = `${API_URL()}v1/startup/application-counters`;

export const MENTOR_LIST = `${API_URL()}v1/mentor/list-paged`;
export const MENTOR_REQUEST_MENTORS_LIST = `${API_URL()}v1/mentor_algo_ml/view_requests_for_startup`;
export const VIEW_MENTOR_APPLICATION_DATA = `${API_URL()}v1/mentor/view-application-mentor`;
export const DASHBOARD_MENTOR_HOME = `${API_URL()}v1/mentor/view-application-mentor`;
export const DASHBOARD_STARTUP_HOME = `${API_URL()}v1/mentor/view-application-mentor`;
export const ABOUT_US = `${REACT_DRUPAL_URL()}msp/api/v1/about`;
export const BECOME_MENTOR_DATA = `${REACT_DRUPAL_URL()}msp/api/v1/become-a-mentor`;
export const GUIDED_INSTRUCTIONS = `${REACT_DRUPAL_URL()}msp/api/v1/guidedinstructions`;
export const COHORT_DATA = `${REACT_DRUPAL_URL()}msp/api/v1/cohort-programs`;
export const GET_A_MENTOR_DATA = `${REACT_DRUPAL_URL()}msp/api/v1/get-a-mentor`;
export const BECOME_MENTOR_LIST = `${API_URL()}v1/mentor/list`;
export const GET_SIGNAL_MENTOR_DATA = `${API_URL()}v1/mentor/view`;
export const CONTACT_SUBMIT_DATA = `${API_URL()}v1/contact-us`;
export const FAQ_PAGE_DATA = `${REACT_DRUPAL_URL()}msp/api/v1/faq`;
export const ALL_STARTUP_LIST = `${API_URL()}v1/startup/list`;
export const ALL_APPLICATION_STARTUP_LIST = `${API_URL()}v1/startup/list-application-paged`;
export const ALL_STARTUP_SEARCH_REQUEST_SUBMIT = `${API_URL()}v1/mentor_algo_ml/mentorship_search`;
export const ALL_STARTUP_SEARCH_REQUEST_SUBMIT_NEW = `${API_URL()}v1/mentor_algo_ml/searchAndSendMentorship`;
export const ALL_MENTOR_SEARCH_REQUEST_SUBMIT_NEW = `${API_URL()}v1/mentor_algo_ml/mentor/searchAndSendMentorship`;
export const GET_SUMMARY_DATA = `${API_URL()}v1/connect/getSessionMOMSummary`;
export const POST_SUMMARY_STARTUP_DATA = `${API_URL()}v1/connect/submitStartupSessionMOMSummary`;
export const POST_SUMMARY_MENTOR_DATA = `${API_URL()}v1/connect/submitMentorSessionMOMSummary`;
export const DELETE_SESSION_STARTUP_DATA = `${API_URL()}v1/connect/deleteScheduleSession`;
export const DELETE_MESSAGE_DATA = `${API_URL()}v1/im/deleteMessage`;
export const POST_STARTUP_FEEDBACK = `${API_URL()}v1/mentorship/addFeedbackByStartup`;
export const GET_STARTUP_FEEDBACK = `${API_URL()}v1/mentorship/getFeedbackByStartup`;
export const POST_MENTOR_FEEDBACK = `${API_URL()}v1/mentorship/addFeedbackByMentor`;
export const GET_MENTOR_FEEDBACK = `${API_URL()}v1/mentorship/getFeedbackByMentor`;
export const POST_ENGAGEMENT_NOTES = `${API_URL()}v1/connect/sample/sample`;
export const GET_ENGAGEMENT_NOTES = `${API_URL()}v1/mentorship/getEngagementNotes`;
export const POST_UPLOAD_DOCUMENT = `${API_URL()}v1/mentor_algo_ml/uploadMentorshipDoc`;
export const GET_STARTUP_MENTORSHIP_COUNTER = `${API_URL()}v1/mentor_algo_ml/requests_counter_for_mentor`;
export const MY_MENTOR_COUNTER = `${API_URL()}v1/mymentor/counters`;
export const MY_STARTUPS_COUNTER = `${API_URL()}v1/mystartup/counters`;
export const POST_PROGRESS_REPORT = `${API_URL()}v1/mentorship/uploadProgressReport`;
// export const POST_PROGRESS_REPORT = `${API_URL()}v1/mentor_algo_ml/uploadMentorshipDoc`;
// export const POST_UPLOAD_DOCUMENT = `${API_URL()}v1/mentorship/uploadProgressReport`;
export const GET_UPLOAD_DOCUMENT_LIST = `${API_URL()}v1/connect/test/test`;
export const POST_IM_MESSAGE = `${API_URL()}v1/im/send_message`;
export const POST_ALL_IM_MESSAGES = `${API_URL()}v1/im/messages`;

// export const STARTUP_APPLICATION = `${API_URL()}v1/mentor_algo_ml/mentor_search_request_list`;
export const MENTORSHIP_APPLICATION = `${API_URL()}v1/test/test`;
export const MENTORSHIP_STARTUP_APPLICATION = `${API_URL()}v1/mentor_algo_ml/view_requests_for_mentor`;
export const MENTORSHIP_STARTUP_APPLICATION_STATUS = `${API_URL()}v1/mentor_algo_ml/update_mentorship_request`;

export const SAVE_DRAFT_MENTOR = `${API_URL()}v1/mentor/saveAsDraft`;
export const STARTUP_APPLICATION = `${API_URL()}v1/mentor_algo_ml/search_list_for_admin`;
export const SESSION_DETAILS = `${API_URL()}v1/sample/sample`;
export const SUMMARY_DETAILS = `${API_URL()}v1/sample/sample`;

// MENTORSHIP REQUESTS
export const ALL_MENTORSHIPS_LIST = `${API_URL()}v1/mentorship/list/ids`;
export const ALL_MENTORSHIPS_ADMIN = `${API_URL()}v1/mentorship/getMentorshipsSummary`;
export const MENTOR_SEARCH_REQUEST_LIST = `${API_URL()}v1/mentor_algo_ml/mentor_search_request_list`;
export const MENTOR_MATCH_LIST = `${API_URL()}v1/mentor_algo_ml/get_mentor_match_list_by_search_id`;
export const SEND_REQUEST_TO_MENTOR = `${API_URL()}v1/mentor_algo_ml/send_request_to_mentor`;
export const SEARCH_LIST_COUNTERS = `${API_URL()}v1/mentor_algo_ml/search_list_counters`;
export const MY_MENTORS_COUNTER = `${API_URL()}v1/mentor_algo_ml/my_mentor_counters`;
export const MENTORSHIPS_COUNTER = `${API_URL()}v1/mentor_algo_ml/myMentorshipsCounters`;
export const MY_MENTORS_LIST = `${API_URL()}v1/mentor_algo_ml/getMyMentors`;
export const MY_MENTORSHIP_LIST = `${API_URL()}v1/mentor_algo_ml/getMyMentorships`;
export const MENTORSHIP_ENGAGEMENT_SUMMARY = `${API_URL()}v1/mentorship/getSummary`;
export const MENTORSHIP_ENGAGEMENT_MEETING = `${API_URL()}v1/connect/get_meeting_link`;
export const MENTORSHIP_SCHEDULE_SESSION = `${API_URL()}v1/connect/scheduleSession`;
export const MENTORSHIP_SESSIONS_LIST = `${API_URL()}v1/connect/getScheduleSession`;
export const MENTORSHIP_SESSION_UPDATE = `${API_URL()}v1/connect/updateScheduleSession`;
export const MENTORSHIP_SESSION_PLAN_CONFIRM = `${API_URL()}v1/mentorship/update_overview`;
export const MENTORSHIP_ALL = `${API_URL()}v1/mentorship/getMentorships`;
export const MENTORS_MENTORSHIP_LIST = `${API_URL()}v1/mentorship/getMentorshipsOfMentors`;
export const GET_NAMES_DATA = `${API_URL()}v1/user/name/list`;
export const GET_ACTIVITY_SUMMARY_MENTOR_DATA = `${API_URL()}v1/user/name/activityList`;

//startup dashboard cohort request
export const COHORT_REQUEST_STARTUP_DASHBOARD = `${API_URL()}v1/cohort/get-startup-cohort-list`;
export const COHORT_REQUEST_MENTOR_DASHBOARD = `${API_URL()}v1/cohort/get-mentor-cohort-list`;

export const MENTOR_ENGAGEMENT_NOTES = `${API_URL()}v1/mentorship/submitMentorEngagementNotes`;
export const STARTUP_ENGAGEMENT_NOTES = `${API_URL()}v1/mentorship/submitStartupEngagementNotes`;
export const GET_NEW_MESSAGES = `${API_URL()}v1/im/messageCount`;
export const GET_MENTOR_COHORT_APPLICATIONS = `${API_URL()}v1/cohort/cohortApplication/list`;
export const GET_MENTOR_MODULE_COHORT_LIST = `${API_URL()}v1/cohort/get-mentor-cohort-list`;
export const COHORTS_DISCUSSION_POST_API = `${API_URL()}v1/db/addPost`;
export const COHORTS_DISCUSSION_LIST_API = `${API_URL()}v1/db/post/list`;
export const COHORTS_DISCUSSION_POST_COMMENT_API = `${API_URL()}v1/db/addComment`;
export const COHORTS_LIKE_POST_COMMENT_API = `${API_URL()}v1/db/comment/opinion`;
export const COHORTS_LIKE_POST_THREAD_API = `${API_URL()}v1/db/post/opinion`;
export const COHORTS_UNLIKE_POST_THREAD_API = `${API_URL()}v1/db/post/remove/opinion`;
export const COHORTS_UNLIKE_POST_COMMENT_API  = `${API_URL()}v1/db/comment/remove/opinion`;
export const COHORTS_THREAD_POST_REMOVE_API  = `${API_URL()}v1/db/post/delete`;
export const COHORTS_POST_COMMENT_REMOVE_API  = `${API_URL()}v1/db/comment/delete`;
export const COHORTS_POST_COMMENT_REPLY_API  = `${API_URL()}v1/db/addComment`;
export const COHORTS_POST_COMMENT_REPLY_LIST_API  = `${API_URL()}v1/db/comments/list`;
export const COHORTS_DASHBOARD_ACTIVITY_API  = `${API_URL()}v1/db/user/activity`;
export const COHORTS_DASHBOARD_MENTOR_API  = `${API_URL()}v1/cohort/cohortMentorsCounter`;
export const COHORTS_DASHBOARD_STARTUP_API  = `${API_URL()}v1/cohort/cohortStartupsCounter`;
export const COHORTS_DISCUSSION_COMMENT_LIST_API = `${API_URL()}v1/db/comments/list`;
export const GET_MENTOR_MODULE_STARTUP_COHORT_LIST = `${API_URL()}v1/cohort/get-startup-cohort-list`;
export const GET_MENTOR_MODULE_COHORT_COUNTER = `${API_URL()}v1/cohort/cohort-ount`;
export const GET_MENTOR_MODULE_STARTUP_COHORT_COUNTER = `${API_URL()}v1/cohort/get-startup-cohort-list`;
export const GET_MENTOR_MODULE_COHORT_STATUS = `${API_URL()}v1/cohort/update-mentor-cohort-request`;
export const GET_MENTOR_MODULE_STARTUP_COHORT_STATUS = `${API_URL()}v1/cohort/update-startup-cohort-request`;
export const SET_ADMIN_COHORT_STATUS = `${API_URL()}v1/cohort/update-application`;
export const COHORT_APPLICATIONS_COUNTER = `${API_URL()}v1/cohort/application-counters`;

export const DOWNLOAD_EXCEL_MENTOR = `${API_URL()}v1/mentor/downloadExcel`;
export const DOWNLOAD_EXCEL_MENTOR_RESPONDED_ALL_REQUEST = `${API_URL()}v1/mentor/excelMentorRespondedToAllRequest`;
export const DOWNLOAD_EXCEL_MENTOR_STARTUP_REQUEST_NULL = `${API_URL()}v1/mentor/excelMentorNoRequestReceivedFromStartup`;
export const DOWNLOAD_EXCEL_MENTOR_NOT_LOGGED_IN = `${API_URL()}v1/mentor/excelMentorNotLoggedIn`;
export const DOWNLOAD_EXCEL_MENTOR_MULTIPLE_REQUEST_RECEIVED = `${API_URL()}v1/mentor/excelMentorMultipleRequestReceived`;

export const DOWNLOAD_EXCEL_STARTUP_REQUEST_SENT = `${API_URL()}v1/mentor_algo_ml/excelStartuprequestSent`;
export const DOWNLOAD_EXCEL_STARTUP_REQUEST_ACCEPTED = `${API_URL()}v1/mentor_algo_ml/excelStartuprequestAccepted`;
export const DOWNLOAD_EXCEL_STARTUP_MENTORSHIP_ONGOING = `${API_URL()}v1/mentorship/excelStartupMentorshipOngoing`;
export const DOWNLOAD_EXCEL_STARTUP_HOURS_OF_MENTORSHIP = `${API_URL()}v1/mentorship/excelStartupHoursOfMentorshipReceived`;


export const DOWNLOAD_EXCEL_MENTORSHIP_REQUEST_RAISED = `${API_URL()}v1/mentorship/excelMentorshipRequestRaised`;
export const DOWNLOAD_EXCEL_ACTIVE_SESSION = `${API_URL()}v1/mentorship/excelActiveMentorshipSession`;
export const DOWNLOAD_EXCEL_MENTORSHIP_NO_SESSION  = `${API_URL()}v1/mentorship/downloadExcelForMentorshipWithNoSession`;

export const DOWNLOAD_EXCEL_TOTAL_COHORTS = `${API_URL()}v1/cohort/TotalCohortCreated`;
export const DOWNLOAD_EXCEL_TOTAL_COHORT_STARTUPS = `${API_URL()}v1/cohort/TotalStartupsInCohort`;
export const DOWNLOAD_EXCEL_TOTAL_COHORT_MENTORS  = `${API_URL()}v1/cohort/TotalMentorInCohort`;
export const DOWNLOAD_EXCEL_TOTAL_COHORT_MENTORSHIP_HOURS = `${API_URL()}v1/cohort/TotalCohortMentorshipHours`;

export const DOWNLOAD_EXCEL_MENTOR_REQUEST = `${API_URL()}v1/mentor_algo_ml/requestsByMentor/downloadExcel`;
export const DOWNLOAD_EXCEL_STARTUP = `${API_URL()}v1/startup/downloadExcel`;
export const DOWNLOAD_EXCEL_STARTUP_REQUEST = `${API_URL()}v1/mentor_algo_ml/mentorshipRequest/downloadExcel`;
export const DOWNLOAD_EXCEL_COHORT = `${API_URL()}v1/cohort/downloadExcel`;
export const DOWNLOAD_EXCEL_ALLMENTORSHIP = `${API_URL()}v1/mentorship/summary/downloadExcel`;

export const GET_ACTIVITY_SUMMARY_DASHBOARD = `${API_URL()}v1/mentor/mentorActivitySummaryCounts`;
export const ACTIVITY_SUMMARY_MENTORSHIP_COUNTS = `${API_URL()}v1/mentorship/activitySummaryCounts`;
export const ACTIVITY_SUMMARY_MENTORSHIP_TOTAL = `${API_URL()}v1/mentorship/activity/getRequestRaised`;
export const ACTIVITY_SUMMARY_MENTORSHIP_STATUS = `${API_URL()}v1/mentorship/activity/getMentorshipActivity`;
export const ACTIVITY_SUMMARY_STARTUP_COUNTS = `${API_URL()}v1/startup/activitySummaryCounts`;
export const ACTIVITY_SUMMARY_COHORT_COUNTS = `${API_URL()}v1/cohort/cohortMatchCounters`;

export const GET_ACTIVITY_SUMMARY_PERFORMANCE = `${API_URL()}v1/mentor/mentorActivitySummary`;
export const GET_ACTIVITY_SUMMARY_NULL = `${API_URL()}v1/cohort/application-counters`;
export const GET_ACTIVITY_SUMMARY_LOW_ACTIVITY = `${API_URL()}v1/cohort/application-counters`;
export const GET_CREATE_COHORT_GROUP_SESSION = `${API_URL()}v1/cohort-session/create-cohort-group-session`;
export const GET_DELETE_COHORT_GROUP_SESSION = `${API_URL()}v1/cohort-session/delete-cohort-group-session`;
export const GET_DETAILS_COHORT_GROUP_SESSION = `${API_URL()}v1/cohort-session/get-detail-cohort-group-session`;
export const GET_LIST_COHORT_GROUP_SESSION = `${API_URL()}v1/cohort-session/get-list-cohort-group-session`;
export const GET_LIST_COHORT_INVITATION = `${API_URL()}v1/cohort-session/get-invitation-user-list`;
export const GET_LIST_COHORT_GROUP_SESSION_COUNTERS = `${API_URL()}v1/cohort-session/get-count-of-cohort-group-session`;
export const GET_LIST_SESSION_MEMBERS = `${API_URL()}v1/cohort-session/get-invitation-user-list`;
export const UPDATE_SESSION_STATUS = `${API_URL()}v1/cohort-session/update-status-cohort-group-session`;
export const COHORT_SESSION_GIVE_FEEDBACK = `${API_URL()}v1/cohort-session/submit-feedback`;
export const COHORT_SESSION_VIEW_FEEDBACK = `${API_URL()}v1/cohort-session/get-feedback`;
export const COHORT_COMMON_LIST_POST = `${API_URL()}v1/cohort/cohortV2Application/list`;
export const COHORT_SESSION_NOTES_GIVE_FEEDBACK = `${API_URL()}v1/cohort-session/submit-session-notes`;
export const COHORT_SESSION_NOTES_VIEW_FEEDBACK = `${API_URL()}v1/cohort-session/view-session-note`;
export const COHORT_GROUP_SESSION_HOURS = `${API_URL()}v1/cohort/cohortApplication/session-hours-details`;
export const COHORT_GROUP_SESSION_HOURS_FILTER = `${API_URL()}v1/cohort/cohortApplication/bycohortid`;
export const COHORT_PROGRAM_SPOTLIGHT_POST = `${API_URL()}v1/cohort/adminFlagEnable`;

export const MATCH_COHORT_TABLE = `${API_URL()}v1/cohort/cohortSummary`;
export const MATCH_STARTUP_LIST = `${API_URL()}v1/cohort/startup/list`;
export const MATCH_MENTOR_LIST = `${API_URL()}v1/cohort/mentor/list`;
export const MATCH_GROUP_MESSAGES = `${API_URL()}v1/im/createAndSendMessageToGroup`;
export const MATCH_CREATE_REQUEST = `${API_URL()}v1/cohort/createMatch`;
export const MATCH_RESULT_LIST = `${API_URL()}v1/cohort/cohortMentorships`;
export const MATCH_RESULT_LIST_STARTUP = `${API_URL()}v1/cohort/cohortMentorshipsByStartup`;
///TWITTER
export const TWITTER_GET_TOKEN = `${API_URL()}v1/twitter/getAuthToken?callback=`;
export const TWITTER_VALIDATE_TOKEN = `${API_URL()}v1/twitter/authenticateUser?`;


export const ENCRYPT_PASSWORD_KEY = `${API_URL()}v1/salt`;


// MESSAGING
export const ALL_CONVERSATION = `${API_URL()}v1/im/getAllConversations`;
export const ALL_CONVERSATION_GROUP = `${API_URL()}v1/im/getAllGroups`;
export const MESSAGES = `${API_URL()}v1/im/messages`;
export const SEND_MESSAGE = `${API_URL()}v1/im/send_message`;
export const SESSION_CALENDAR = `${API_URL()}v1/connect/getSessionCalendar`;
export const VIEW_BROADCAST_MESSAGES = `${API_URL()}v1/im/broadcastMessages`;

// COHORT
export const ALL_COHORT_PROGRAMS = `${API_URL()}v1/cohort/cohortApplication/list`;
export const COHORT_PARTICULAR = `${API_URL()}v1/cohort/view-application`;
export const COHORT_SEND_MENTOR_REQUEST = `${API_URL()}v1/cohort/send-request-mentor-to-cohort`;
export const COHORT_USER_SEND_REQUEST = `${API_URL()}v1/cohort/joinCohort`;
export const COHORT_USER_EXIT_REQUEST = `${API_URL()}v1/cohort/leaveCohort`;
export const COHORT_CLOSE_REQUEST = `${API_URL()}v1/cohort/closeCohortProgram`;
export const SCHEDULE_RESOURCES_COUNTER = `${API_URL()}v1/cohort-session/getCountOfCohortGroupSession`;
export const ALL_COHORT_NAMES_LIST = `${API_URL()}v1/cohort/name/list`;
export const ALL_COHORT_ORGANIZATION_LIST = `${API_URL()}v1/cohort/organization/list`;
export const SEND_REQUEST_STARTUP__TO_COHORT = `${API_URL()}v1/cohort/send-request-startup-to-cohort`;
export const COHORT_ADMIN_MENTORSHIPS = `${API_URL()}v1/cohort/admin/cohortMentorships`;
export const COHORT_APPLICATION_LIST = `${API_URL()}v1/cohort/cohortApplication/list`;
export const COHORT_ADD_RESOURCES = `${API_URL()}v1/db/addResource`;
export const COHORT_VIEW_ALL_RESOURCES = `${API_URL()}v1/db/resource/list`;

// `${API_URL()}v1/mentor_algo_ml/mentor_search_request_list`
